import { DeliveryMode } from '../constants';
const { ECDN11, WEBRTC } = DeliveryMode;

function getMode(char: string): DeliveryMode | undefined {
  switch (char) {
    case 'e':
      return ECDN11;
    case 'b':
      return WEBRTC;
  }
}

export default function getPlaybackPriority(priority: string): DeliveryMode[] {
  if (priority) {
    return priority
      .split('')
      .reduce((acc: DeliveryMode[], c: string): DeliveryMode[] => {
        const m = getMode(c);
        return m ? [...acc, m] : acc;
      }, []);
  }
  return [];
}
